/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const parseFile = /* GraphQL */ `
  query ParseFile(
    $jsonKey: [String]
    $generalKey: String
    $logoKey: String
    $folderName: String
    $backgroundImageKey: String
  ) {
    parseFile(
      jsonKey: $jsonKey
      generalKey: $generalKey
      logoKey: $logoKey
      folderName: $folderName
      backgroundImageKey: $backgroundImageKey
    )
  }
`;
export const listUsersByGroup = /* GraphQL */ `
  query ListUsersByGroup($groupName: String) {
    listUsersByGroup(groupName: $groupName)
  }
`;
export const manageUsers = /* GraphQL */ `
  query ManageUsers(
    $userName: String
    $firstName: String
    $lastName: String
    $email: String
    $groupName: String
  ) {
    manageUsers(
      userName: $userName
      firstName: $firstName
      lastName: $lastName
      email: $email
      groupName: $groupName
    )
  }
`;
export const me = /* GraphQL */ `
  query Me {
    me {
      enabled
    }
  }
`;
export const listPlans = /* GraphQL */ `
  query ListPlans(
    $filter: ModelPlanFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPlans(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        price {
          amount
          currency
          unit
        }
        description
        interval
        pricePerMonth {
          amount
          currency
          unit
        }
        pricePerYear {
          amount
          currency
          unit
        }
        active
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getPlan = /* GraphQL */ `
  query GetPlan($id: ID!) {
    getPlan(id: $id) {
      id
      name
      price {
        amount
        currency
        unit
      }
      description
      interval
      pricePerMonth {
        amount
        currency
        unit
      }
      pricePerYear {
        amount
        currency
        unit
      }
      active
      createdAt
      updatedAt
    }
  }
`;
export const listRestaurants = /* GraphQL */ `
  query ListRestaurants(
    $filter: ModelRestaurantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRestaurants(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        userId
        groupName
        restaurantUrl
        displayDate
        displayLogo
        displayCurrencySymbol
        introduction
        logoKey
        displayLogoInQRCode
        backgroundImageKey
        displayBackground
        restaurantName {
          font
          color
          textstyle
          format
        }
        dateText {
          font
          color
          textstyle
          format
        }
        descriptionText {
          font
          color
          textstyle
          format
        }
        menusPosition
        paidMenus
        migratedMenuId
        paidMenuImages
        bookmarksEnabled
        paidBookmarks
        loadSectionOnly
        cognitoUsername
        zoomDisabled
        createdAt
        updatedAt
        menus {
          items {
            id
            name
            description
            qrCodeImage
            menuUrl
            fileLocation
            isPublished
            menuLayout
            createdAt
            updatedAt
            restaurant {
              id
              name
              userId
              groupName
              restaurantUrl
              displayDate
              displayLogo
              displayCurrencySymbol
              introduction
              logoKey
              displayLogoInQRCode
              backgroundImageKey
              displayBackground
              menusPosition
              paidMenus
              migratedMenuId
              paidMenuImages
              bookmarksEnabled
              paidBookmarks
              loadSectionOnly
              cognitoUsername
              zoomDisabled
              createdAt
              updatedAt
            }
            menuSetting {
              id
              displayDate
              displayCurrencySymbol
              displayLogo
              introduction
              logoKey
              createdAt
              updatedAt
            }
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getRestaurant = /* GraphQL */ `
  query GetRestaurant($id: ID!) {
    getRestaurant(id: $id) {
      id
      name
      userId
      groupName
      restaurantUrl
      displayDate
      displayLogo
      displayCurrencySymbol
      introduction
      logoKey
      displayLogoInQRCode
      backgroundImageKey
      displayBackground
      restaurantName {
        font
        color
        textstyle
        format
      }
      dateText {
        font
        color
        textstyle
        format
      }
      descriptionText {
        font
        color
        textstyle
        format
      }
      menusPosition
      paidMenus
      migratedMenuId
      paidMenuImages
      bookmarksEnabled
      paidBookmarks
      loadSectionOnly
      cognitoUsername
      zoomDisabled
      createdAt
      updatedAt
      menus {
        items {
          id
          name
          description
          qrCodeImage
          menuUrl
          fileLocation
          isPublished
          menuLayout
          createdAt
          updatedAt
          restaurant {
            id
            name
            userId
            groupName
            restaurantUrl
            displayDate
            displayLogo
            displayCurrencySymbol
            introduction
            logoKey
            displayLogoInQRCode
            backgroundImageKey
            displayBackground
            restaurantName {
              font
              color
              textstyle
              format
            }
            dateText {
              font
              color
              textstyle
              format
            }
            descriptionText {
              font
              color
              textstyle
              format
            }
            menusPosition
            paidMenus
            migratedMenuId
            paidMenuImages
            bookmarksEnabled
            paidBookmarks
            loadSectionOnly
            cognitoUsername
            zoomDisabled
            createdAt
            updatedAt
            menus {
              nextToken
            }
          }
          menuSetting {
            id
            displayDate
            displayCurrencySymbol
            displayLogo
            introduction
            logoKey
            headerOne {
              font
              color
              textstyle
              format
            }
            headerTwo {
              font
              color
              textstyle
              format
            }
            headerThree {
              font
              color
              textstyle
              format
            }
            headerFour {
              font
              color
              textstyle
              format
            }
            normalText {
              font
              color
              textstyle
              format
            }
            subtext {
              font
              color
              textstyle
              format
            }
            createdAt
            updatedAt
            menu {
              id
              name
              description
              qrCodeImage
              menuUrl
              fileLocation
              isPublished
              menuLayout
              createdAt
              updatedAt
            }
          }
        }
        nextToken
      }
    }
  }
`;
export const restaurantsByUserId = /* GraphQL */ `
  query RestaurantsByUserId(
    $userId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelRestaurantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    restaurantsByUserId(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        userId
        groupName
        restaurantUrl
        displayDate
        displayLogo
        displayCurrencySymbol
        introduction
        logoKey
        displayLogoInQRCode
        backgroundImageKey
        displayBackground
        restaurantName {
          font
          color
          textstyle
          format
        }
        dateText {
          font
          color
          textstyle
          format
        }
        descriptionText {
          font
          color
          textstyle
          format
        }
        menusPosition
        paidMenus
        migratedMenuId
        paidMenuImages
        bookmarksEnabled
        paidBookmarks
        loadSectionOnly
        cognitoUsername
        zoomDisabled
        createdAt
        updatedAt
        menus {
          items {
            id
            name
            description
            qrCodeImage
            menuUrl
            fileLocation
            isPublished
            menuLayout
            createdAt
            updatedAt
            restaurant {
              id
              name
              userId
              groupName
              restaurantUrl
              displayDate
              displayLogo
              displayCurrencySymbol
              introduction
              logoKey
              displayLogoInQRCode
              backgroundImageKey
              displayBackground
              menusPosition
              paidMenus
              migratedMenuId
              paidMenuImages
              bookmarksEnabled
              paidBookmarks
              loadSectionOnly
              cognitoUsername
              zoomDisabled
              createdAt
              updatedAt
            }
            menuSetting {
              id
              displayDate
              displayCurrencySymbol
              displayLogo
              introduction
              logoKey
              createdAt
              updatedAt
            }
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const restaurantsByGroupName = /* GraphQL */ `
  query RestaurantsByGroupName(
    $groupName: String
    $sortDirection: ModelSortDirection
    $filter: ModelRestaurantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    restaurantsByGroupName(
      groupName: $groupName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        userId
        groupName
        restaurantUrl
        displayDate
        displayLogo
        displayCurrencySymbol
        introduction
        logoKey
        displayLogoInQRCode
        backgroundImageKey
        displayBackground
        restaurantName {
          font
          color
          textstyle
          format
        }
        dateText {
          font
          color
          textstyle
          format
        }
        descriptionText {
          font
          color
          textstyle
          format
        }
        menusPosition
        paidMenus
        migratedMenuId
        paidMenuImages
        bookmarksEnabled
        paidBookmarks
        loadSectionOnly
        cognitoUsername
        zoomDisabled
        createdAt
        updatedAt
        menus {
          items {
            id
            name
            description
            qrCodeImage
            menuUrl
            fileLocation
            isPublished
            menuLayout
            createdAt
            updatedAt
            restaurant {
              id
              name
              userId
              groupName
              restaurantUrl
              displayDate
              displayLogo
              displayCurrencySymbol
              introduction
              logoKey
              displayLogoInQRCode
              backgroundImageKey
              displayBackground
              menusPosition
              paidMenus
              migratedMenuId
              paidMenuImages
              bookmarksEnabled
              paidBookmarks
              loadSectionOnly
              cognitoUsername
              zoomDisabled
              createdAt
              updatedAt
            }
            menuSetting {
              id
              displayDate
              displayCurrencySymbol
              displayLogo
              introduction
              logoKey
              createdAt
              updatedAt
            }
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const listMenus = /* GraphQL */ `
  query ListMenus(
    $filter: ModelMenuFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMenus(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        qrCodeImage
        menuUrl
        fileLocation
        isPublished
        menuLayout
        createdAt
        updatedAt
        restaurant {
          id
          name
          userId
          groupName
          restaurantUrl
          displayDate
          displayLogo
          displayCurrencySymbol
          introduction
          logoKey
          displayLogoInQRCode
          backgroundImageKey
          displayBackground
          restaurantName {
            font
            color
            textstyle
            format
          }
          dateText {
            font
            color
            textstyle
            format
          }
          descriptionText {
            font
            color
            textstyle
            format
          }
          menusPosition
          paidMenus
          migratedMenuId
          paidMenuImages
          bookmarksEnabled
          paidBookmarks
          loadSectionOnly
          cognitoUsername
          zoomDisabled
          createdAt
          updatedAt
          menus {
            items {
              id
              name
              description
              qrCodeImage
              menuUrl
              fileLocation
              isPublished
              menuLayout
              createdAt
              updatedAt
            }
            nextToken
          }
        }
        menuSetting {
          id
          displayDate
          displayCurrencySymbol
          displayLogo
          introduction
          logoKey
          headerOne {
            font
            color
            textstyle
            format
          }
          headerTwo {
            font
            color
            textstyle
            format
          }
          headerThree {
            font
            color
            textstyle
            format
          }
          headerFour {
            font
            color
            textstyle
            format
          }
          normalText {
            font
            color
            textstyle
            format
          }
          subtext {
            font
            color
            textstyle
            format
          }
          createdAt
          updatedAt
          menu {
            id
            name
            description
            qrCodeImage
            menuUrl
            fileLocation
            isPublished
            menuLayout
            createdAt
            updatedAt
            restaurant {
              id
              name
              userId
              groupName
              restaurantUrl
              displayDate
              displayLogo
              displayCurrencySymbol
              introduction
              logoKey
              displayLogoInQRCode
              backgroundImageKey
              displayBackground
              menusPosition
              paidMenus
              migratedMenuId
              paidMenuImages
              bookmarksEnabled
              paidBookmarks
              loadSectionOnly
              cognitoUsername
              zoomDisabled
              createdAt
              updatedAt
            }
            menuSetting {
              id
              displayDate
              displayCurrencySymbol
              displayLogo
              introduction
              logoKey
              createdAt
              updatedAt
            }
          }
        }
      }
      nextToken
    }
  }
`;
export const getMenu = /* GraphQL */ `
  query GetMenu($id: ID!) {
    getMenu(id: $id) {
      id
      name
      description
      qrCodeImage
      menuUrl
      fileLocation
      isPublished
      menuLayout
      createdAt
      updatedAt
      restaurant {
        id
        name
        userId
        groupName
        restaurantUrl
        displayDate
        displayLogo
        displayCurrencySymbol
        introduction
        logoKey
        displayLogoInQRCode
        backgroundImageKey
        displayBackground
        restaurantName {
          font
          color
          textstyle
          format
        }
        dateText {
          font
          color
          textstyle
          format
        }
        descriptionText {
          font
          color
          textstyle
          format
        }
        menusPosition
        paidMenus
        migratedMenuId
        paidMenuImages
        bookmarksEnabled
        paidBookmarks
        loadSectionOnly
        cognitoUsername
        zoomDisabled
        createdAt
        updatedAt
        menus {
          items {
            id
            name
            description
            qrCodeImage
            menuUrl
            fileLocation
            isPublished
            menuLayout
            createdAt
            updatedAt
            restaurant {
              id
              name
              userId
              groupName
              restaurantUrl
              displayDate
              displayLogo
              displayCurrencySymbol
              introduction
              logoKey
              displayLogoInQRCode
              backgroundImageKey
              displayBackground
              menusPosition
              paidMenus
              migratedMenuId
              paidMenuImages
              bookmarksEnabled
              paidBookmarks
              loadSectionOnly
              cognitoUsername
              zoomDisabled
              createdAt
              updatedAt
            }
            menuSetting {
              id
              displayDate
              displayCurrencySymbol
              displayLogo
              introduction
              logoKey
              createdAt
              updatedAt
            }
          }
          nextToken
        }
      }
      menuSetting {
        id
        displayDate
        displayCurrencySymbol
        displayLogo
        introduction
        logoKey
        headerOne {
          font
          color
          textstyle
          format
        }
        headerTwo {
          font
          color
          textstyle
          format
        }
        headerThree {
          font
          color
          textstyle
          format
        }
        headerFour {
          font
          color
          textstyle
          format
        }
        normalText {
          font
          color
          textstyle
          format
        }
        subtext {
          font
          color
          textstyle
          format
        }
        createdAt
        updatedAt
        menu {
          id
          name
          description
          qrCodeImage
          menuUrl
          fileLocation
          isPublished
          menuLayout
          createdAt
          updatedAt
          restaurant {
            id
            name
            userId
            groupName
            restaurantUrl
            displayDate
            displayLogo
            displayCurrencySymbol
            introduction
            logoKey
            displayLogoInQRCode
            backgroundImageKey
            displayBackground
            restaurantName {
              font
              color
              textstyle
              format
            }
            dateText {
              font
              color
              textstyle
              format
            }
            descriptionText {
              font
              color
              textstyle
              format
            }
            menusPosition
            paidMenus
            migratedMenuId
            paidMenuImages
            bookmarksEnabled
            paidBookmarks
            loadSectionOnly
            cognitoUsername
            zoomDisabled
            createdAt
            updatedAt
            menus {
              nextToken
            }
          }
          menuSetting {
            id
            displayDate
            displayCurrencySymbol
            displayLogo
            introduction
            logoKey
            headerOne {
              font
              color
              textstyle
              format
            }
            headerTwo {
              font
              color
              textstyle
              format
            }
            headerThree {
              font
              color
              textstyle
              format
            }
            headerFour {
              font
              color
              textstyle
              format
            }
            normalText {
              font
              color
              textstyle
              format
            }
            subtext {
              font
              color
              textstyle
              format
            }
            createdAt
            updatedAt
            menu {
              id
              name
              description
              qrCodeImage
              menuUrl
              fileLocation
              isPublished
              menuLayout
              createdAt
              updatedAt
            }
          }
        }
      }
    }
  }
`;
export const listMenuSettings = /* GraphQL */ `
  query ListMenuSettings(
    $filter: ModelMenuSettingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMenuSettings(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        displayDate
        displayCurrencySymbol
        displayLogo
        introduction
        logoKey
        headerOne {
          font
          color
          textstyle
          format
        }
        headerTwo {
          font
          color
          textstyle
          format
        }
        headerThree {
          font
          color
          textstyle
          format
        }
        headerFour {
          font
          color
          textstyle
          format
        }
        normalText {
          font
          color
          textstyle
          format
        }
        subtext {
          font
          color
          textstyle
          format
        }
        createdAt
        updatedAt
        menu {
          id
          name
          description
          qrCodeImage
          menuUrl
          fileLocation
          isPublished
          menuLayout
          createdAt
          updatedAt
          restaurant {
            id
            name
            userId
            groupName
            restaurantUrl
            displayDate
            displayLogo
            displayCurrencySymbol
            introduction
            logoKey
            displayLogoInQRCode
            backgroundImageKey
            displayBackground
            restaurantName {
              font
              color
              textstyle
              format
            }
            dateText {
              font
              color
              textstyle
              format
            }
            descriptionText {
              font
              color
              textstyle
              format
            }
            menusPosition
            paidMenus
            migratedMenuId
            paidMenuImages
            bookmarksEnabled
            paidBookmarks
            loadSectionOnly
            cognitoUsername
            zoomDisabled
            createdAt
            updatedAt
            menus {
              nextToken
            }
          }
          menuSetting {
            id
            displayDate
            displayCurrencySymbol
            displayLogo
            introduction
            logoKey
            headerOne {
              font
              color
              textstyle
              format
            }
            headerTwo {
              font
              color
              textstyle
              format
            }
            headerThree {
              font
              color
              textstyle
              format
            }
            headerFour {
              font
              color
              textstyle
              format
            }
            normalText {
              font
              color
              textstyle
              format
            }
            subtext {
              font
              color
              textstyle
              format
            }
            createdAt
            updatedAt
            menu {
              id
              name
              description
              qrCodeImage
              menuUrl
              fileLocation
              isPublished
              menuLayout
              createdAt
              updatedAt
            }
          }
        }
      }
      nextToken
    }
  }
`;
export const getMenuSetting = /* GraphQL */ `
  query GetMenuSetting($id: ID!) {
    getMenuSetting(id: $id) {
      id
      displayDate
      displayCurrencySymbol
      displayLogo
      introduction
      logoKey
      headerOne {
        font
        color
        textstyle
        format
      }
      headerTwo {
        font
        color
        textstyle
        format
      }
      headerThree {
        font
        color
        textstyle
        format
      }
      headerFour {
        font
        color
        textstyle
        format
      }
      normalText {
        font
        color
        textstyle
        format
      }
      subtext {
        font
        color
        textstyle
        format
      }
      createdAt
      updatedAt
      menu {
        id
        name
        description
        qrCodeImage
        menuUrl
        fileLocation
        isPublished
        menuLayout
        createdAt
        updatedAt
        restaurant {
          id
          name
          userId
          groupName
          restaurantUrl
          displayDate
          displayLogo
          displayCurrencySymbol
          introduction
          logoKey
          displayLogoInQRCode
          backgroundImageKey
          displayBackground
          restaurantName {
            font
            color
            textstyle
            format
          }
          dateText {
            font
            color
            textstyle
            format
          }
          descriptionText {
            font
            color
            textstyle
            format
          }
          menusPosition
          paidMenus
          migratedMenuId
          paidMenuImages
          bookmarksEnabled
          paidBookmarks
          loadSectionOnly
          cognitoUsername
          zoomDisabled
          createdAt
          updatedAt
          menus {
            items {
              id
              name
              description
              qrCodeImage
              menuUrl
              fileLocation
              isPublished
              menuLayout
              createdAt
              updatedAt
            }
            nextToken
          }
        }
        menuSetting {
          id
          displayDate
          displayCurrencySymbol
          displayLogo
          introduction
          logoKey
          headerOne {
            font
            color
            textstyle
            format
          }
          headerTwo {
            font
            color
            textstyle
            format
          }
          headerThree {
            font
            color
            textstyle
            format
          }
          headerFour {
            font
            color
            textstyle
            format
          }
          normalText {
            font
            color
            textstyle
            format
          }
          subtext {
            font
            color
            textstyle
            format
          }
          createdAt
          updatedAt
          menu {
            id
            name
            description
            qrCodeImage
            menuUrl
            fileLocation
            isPublished
            menuLayout
            createdAt
            updatedAt
            restaurant {
              id
              name
              userId
              groupName
              restaurantUrl
              displayDate
              displayLogo
              displayCurrencySymbol
              introduction
              logoKey
              displayLogoInQRCode
              backgroundImageKey
              displayBackground
              menusPosition
              paidMenus
              migratedMenuId
              paidMenuImages
              bookmarksEnabled
              paidBookmarks
              loadSectionOnly
              cognitoUsername
              zoomDisabled
              createdAt
              updatedAt
            }
            menuSetting {
              id
              displayDate
              displayCurrencySymbol
              displayLogo
              introduction
              logoKey
              createdAt
              updatedAt
            }
          }
        }
      }
    }
  }
`;
